import React from "react";
import styled from "styled-components";
import loadable from "@loadable/component";

import { breakpoints, fontFamily, colors } from "../../../theme";
import { PageSection } from "../../components/layout/layout-styles";
import SplashText from "../../components/SplashText";
import { WhatWeProvideContentFallback } from "../../components/layout/section-skeleton";

const WhatWeProvideContent = loadable(() => import("./what-we-provide-content"));

const Section = styled(PageSection)`
  margin: 0 auto;
  width: 94%;
  max-width: 1040px;
`;

const TitleSection = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

const Heading = styled.h2`
  margin: 0;
  font-family: ${fontFamily.extraBold};
  font-size: 32px;
  line-height: 1.02;

  @media only screen and (min-width: ${breakpoints.desktop}) {
    font-size: 40px;
  }
`;

const Subtitle = styled.p`
  margin: 0;
  font-size: 16px;
  line-height: 1.2;
  font-family: ${fontFamily.medium};
  font-weight: 500;
  color: ${colors.body};
  margin-left: 3px;

  @media only screen and (min-width: ${breakpoints.desktop}) {
    font-size: 20px;
  }
`;

const WhatWeProvideSection = () => {
  return (
    <Section name="what-we-provide" as="section">
      <TitleSection>
        <Heading>
          What We <SplashText variant="accent">Provide</SplashText>
        </Heading>
        <Subtitle>
          We offer end-to-end development support - from building full products
          to improving existing systems.
        </Subtitle>
      </TitleSection>

      <WhatWeProvideContent
        fallback={<WhatWeProvideContentFallback />}
      />
    </Section>
  );
};

export default WhatWeProvideSection;
